import styled from 'styled-components';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 10;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

export const Container = styled.div`
  padding: 24px;
  width: 100%;
  max-width: 450px;
  align-self: center;
  justify-self: center;
  z-index: 10;
  position: fixed;
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 12px 28px rgba(33, 39, 73, 0.2);
  border-radius: 8px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  grid-template-columns: minmax(min-content, 500px) 1fr;

  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled.div`
  color: #161a30;
  font-size: 18px;
  font-weight: 600;
  flex: 1;
`;

export const Close = styled.button`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  padding: 0;
  padding-top: 5px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

interface ILabel {
  status?: string;
}

export const Label = styled.div<ILabel>`
  font-size: 14px;
  font-weight: 400;
  color: #474d66;

  &.mandatory {
    font-size: 12px;
    font-weight: 500;
    margin: 0 0 8px 3px;
  }

  &.optional {
    font-weight: 500;
    font-size: 12px;
    margin: 16px 0 8px 3px;
    color: #8f95b2;
  }

  &.tip {
    font-weight: 400;
    font-size: 12px;
    color: #696f8c;
    line-height: 18px;

    margin: 12px 0 4px 0;
  }

  &.tipBlue {
    font-weight: 500;
    font-size: 12px;
    color: #1371fe;

    cursor: pointer;

    :hover {
      opacity: 0.8;
    }
  }
`;
export {
  Confirm,
  Divider,
  Error,
  Form,
  Input,
  Line,
  Textarea,
} from '@pages/ConfigurationPage/Components/TagsManagement/Components/TagsMenu/Components/EditTagDialog/EditTagDialog.styles';

export const LineDivider = styled.div`
  width: 100%;
  border-bottom: 1px solid #e6e8f0;

  margin-bottom: 24px;
`;
